module.exports = __webpack_public_path__ + "static/media/img2-3.234ff0a1.png";